import { IdleLogoutModal, PageLoader, type UserState, useLogin } from "@sveabank/cc-common";
import { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router";
import { useUser } from "../hooks/useUser";
import { APPCONFIG } from "../utils/config";

const validUserStates: UserState[] = ["LOGGED_IN", "PENDING"];

const ProtectedLayout = () => {
	const navigate = useNavigate();
	const { user, isLoading } = useUser();
	const { doLogout, loginState } = useLogin();

	useEffect(() => {
		if (!validUserStates.includes(loginState)) navigate("/");
	}, [loginState]);

	if (isLoading && loginState !== "PENDING") return <PageLoader />;
	if (!user && loginState !== "PENDING") {
		return <Navigate to="/" />;
	}

	const isDev = APPCONFIG.MODE === "development";

	return (
		<div className="flex min-h-screen flex-col overflow-hidden">
			{loginState === "LOGGED_IN" && <Outlet />}
			<IdleLogoutModal
				onLogout={doLogout}
				timeToWarning={isDev ? 10000000 : 240000}
				timeToLogout={isDev ? 11000000 : 300000}
			/>
		</div>
	);
};

export default ProtectedLayout;
